export default __webpack_public_path__ + "static/media/basic-push-pin-2.61523e37.png";